import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BusinessPlantDetailState } from './business-plant-detail.models';

export const selectBusinessPlantDetailState = createFeatureSelector<BusinessPlantDetailState>('businessPlantDetail');

export const selectBusinessPlantDetailByGuid = (businessPlanGuid: string) =>
  createSelector(selectBusinessPlantDetailState, (state) => state.details[businessPlanGuid] || null);

export const selectBusinessPlantDetailLoading = createSelector(
  selectBusinessPlantDetailState,
  (state) => state.loading,
);

export const selectBusinessPlantDetailError = createSelector(selectBusinessPlantDetailState, (state) => state.error);
